// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ui-autocomplete-input-token {\r\n  padding: 0px;\r\n}\r\n.ui-autocomplete-multiple-container {\r\n  width: 100%;\r\n}", "",{"version":3,"sources":["primeng.autocomplete.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb","file":"primeng.autocomplete.css","sourcesContent":[".ui-autocomplete-input-token {\r\n  padding: 0px;\r\n}\r\n.ui-autocomplete-multiple-container {\r\n  width: 100%;\r\n}"]}]);
// Exports
module.exports = exports;
